export interface SeoOptions {
  title: string;
  description?: string;
  image?: string;
  keywords?: string;
  canonical?: string;
  noindex?: boolean;
}

export const seo = ({
  title,
  description,
  keywords,
  image,
  canonical,
  noindex = false,
}: SeoOptions) => {
  const siteUrl = "https://setupsbyszese.com";
  const resolvedCanonical = canonical || siteUrl;
  const resolvedImage = image || `${siteUrl}/og-image.png`;

  const tags: Record<string, string>[] = [
    { title },
    // og:site_name and og:locale
    { property: "og:site_name", content: "Setups by SZESE" },
    { property: "og:locale", content: "en_US" },
    { property: "og:locale:alternate", content: "hu_HU" },
    { property: "og:type", content: "website" },
    { property: "og:title", content: title },
    { property: "og:url", content: resolvedCanonical },
    // Twitter card
    { name: "twitter:title", content: title },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:site", content: "@szeseesport" },
    { name: "twitter:image", content: resolvedImage },
    // OG image
    { property: "og:image", content: resolvedImage },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
  ];

  // Only emit description/keywords/twitter:description if they have content
  if (description) {
    tags.push(
      { name: "description", content: description },
      { name: "twitter:description", content: description },
      { property: "og:description", content: description },
    );
  }

  if (keywords) {
    tags.push({ name: "keywords", content: keywords });
  }

  if (noindex) {
    tags.push({ name: "robots", content: "noindex, nofollow" });
  }

  return tags;
};

/**
 * Generate a canonical link element for use in route head().links
 */
export const canonicalLink = (url: string) => ({
  rel: "canonical" as const,
  href: url,
});
